import * as ContentService from '@/widgets/services/ContentService.ts';

import {
  resolveWidgetConfig,
  type WidgetConfig
} from '@/domain/WidgetConfig.ts';
import type { PLPRoute } from '@/domain/Route.ts';
import isPreview from '@/widgets/utils/isPreview.ts';

export async function getRemoteData(route: PLPRoute): Promise<{
  config: WidgetConfig;
}> {
  const withCacheBusting = isPreview();
  const config = await ContentService.getProductListHeroBannerConfig(
    route.market,
    route.channel,
    route.locale,
    withCacheBusting
  );

  return {
    config: resolveWidgetConfig(config, route.technology, route.productType)
  };
}
